import store, { User } from '@/store';
import { components } from '@/types/types';
import { AppConfig } from '@/types/config';

export type ApplicationRightKey = components['schemas']['application_right_key'];

type UserWithRights = Pick<User, 'application_rights'> | null | undefined;

export function hasRight(right: ApplicationRightKey, user: UserWithRights = store.getters.user): boolean {
    return Boolean(user?.application_rights?.[right]);
}

export function hasAnyRight(rights: ApplicationRightKey[], user: UserWithRights = store.getters.user): boolean {
    return rights.some((right) => hasRight(right, user));
}

export function hasAllRights(rights: ApplicationRightKey[], user: UserWithRights = store.getters.user): boolean {
    return rights.every((right) => hasRight(right, user));
}

export type NavItem = {
    name: string;
    rights: ApplicationRightKey[];
    enabled?: (config: Partial<AppConfig>) => boolean;
};

export const NAV_ITEMS: NavItem[] = [
    { name: 'contracts', rights: ['contract.list'] },
    { name: 'users', rights: ['users.list', 'users.manage', 'user.create'] },
    { name: 'devices', rights: ['applications.list'] },
    { name: 'clusters', rights: ['clusters.manage', 'clusters.observe'] },
    { name: 'applicationTypes', rights: ['application_types.read', 'application_types.manage'] },
    { name: 'vod', rights: ['vod.list', 'vod.read'] },
    { name: 'sessions', rights: ['sessions.list', 'sessions.read'], enabled: (config) => Boolean(config.enableSessions) },
    { name: 'mosaics', rights: ['mosaics.read', 'mosaics.manage'], enabled: (config) => Boolean(config.enableMosaics) },
    { name: 'hls', rights: ['hls.list', 'hls.read'], enabled: (config) => Boolean(config.enableHls) },
];

export function canAccessNavItem(item: NavItem, config: Partial<AppConfig> = store.state.config): boolean {
    return (item.enabled ? item.enabled(config) : true) && hasAnyRight(item.rights);
}

export function getFirstAllowedRouteName(config: Partial<AppConfig> = store.state.config): string {
    return NAV_ITEMS.find((item) => canAccessNavItem(item, config))?.name || 'contracts';
}
